module.exports = __webpack_public_path__ + "static/img/clock.8db0703.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/customisation/clock.png
// module id = qaUC
// module chunks = 1